import cf from './cf';
import i1zv6_20211024 from './i1zv6_20211024';

export default class i1zv6a extends i1zv6_20211024 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    global.t = this;
    this.d_viewDefs = {
      name: '実績集計表',
      class: 'i1zv6a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
